package com.pincer.client

import com.pincer.core.Logger
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Job
import kotlinx.coroutines.launch
import kotlinx.coroutines.cancelAndJoin
import kotlinx.coroutines.CancellationException

/*
A wrapper for a CoroutineScope which keeps track of started jobs
and allows for them all to be cancelled in one go.

TODO This seems super standard behaviour. Could be something already in kotlinx for this? Or a library?
*/

class JobCentre(val log: Logger, val coroutineScope: CoroutineScope) {

    private val jobs = mutableMapOf<String, Job>()

    private var number = 1L

    fun launch(name: String, block: suspend () -> Unit): Job {
        val jobId = "job-$name-${number++}"
        //log.f("Adding $jobId")
        val job = coroutineScope.launch {
            try {
                //log.f("$jobId starting")
                block()
                //log.f("$jobId completed")
            }
            catch (cancellation: CancellationException) {
                log.i("$jobId cancelled")
                throw cancellation
            }
            catch (exception: Exception) {
                log.w("$jobId failed", exception)
            }
            finally {
                jobs.remove(jobId)
                //log.f("jobId removed, jobs remaining: ${jobs.size}")
            }
        }
        jobs.put(jobId, job)
        //log.f("Job count : ${jobs.size}")
        return job
    }

    fun cancel(jobId: String) = coroutineScope.launch {
        log.i("Cancelling $jobId")
        jobs.get(jobId)?.cancel()
    }

    fun cancelAllJobs() = coroutineScope.launch {
        log.i("Cancelling all jobs")
        val jobsToCancel = mutableSetOf<Job>()
        jobsToCancel.addAll(jobs.values)
        for (job in jobsToCancel) {
            try { job.cancelAndJoin() }
            catch (exception: Exception) { log.w("Ignoring exception cancelling", exception) }
        }
    }

}
